
import { defineComponent, ref, reactive, toRefs, onMounted, watch, computed, nextTick } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import globalsets from '@/utils/globalsets'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '预测指标',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '营业收入（元）',
        dataIndex: 'OpIncome',
        key: 'OpIncome',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '营业收入增长率',
        dataIndex: 'OpIncomeGrowth',
        key: 'OpIncomeGrowth',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '净利润（元）',
        dataIndex: 'PNetProfit',
        key: 'PNetProfit',
        width: '120px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '净利润增长率',
        dataIndex: 'PNetProfitGrowth',
        key: 'PNetProfitGrowth',
        width: '200px',
        ellipsis: true,
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '每股现金流（元）',
        dataIndex: 'PerCashFlow',
        key: 'PerCashFlow',
        width: '200px',
        ellipsis: true,
        slots: { customRender: 'decimal' }
      },
      {
        title: '每股净资产（元）',
        dataIndex: 'BPS',
        key: 'BPS',
        width: '200px',
        ellipsis: true,
        slots: { customRender: 'decimal' }
      },
      {
        title: '净资产收益率',
        dataIndex: 'ROE',
        key: 'ROE',
        width: '200px',
        ellipsis: true,
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '市盈率（动态）',
        dataIndex: 'PE',
        key: 'PE',
        width: '200px',
        ellipsis: true,
        slots: { customRender: 'nocolorincrease' }
      }
    ]
    const route = useRoute()
    watch(
      () => ((props || {}).pageSourceData || {}).TargetDetail,
      (val: any) => {
        let data: any = JSON.parse(JSON.stringify(val))
        if ((data || []).length) {
          data = data.reverse()
          data.forEach((item: any, i: number) => {
            item.index = 'TargetDetail' + i
            if (item.Tag === 1) {
              item.time = '预测' + item.Year + '（平均）'
            }
            if (item.Tag === 0) {
              item.time = item.Year + '（实际值）'
            }
          })
          pageData.data = data
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )

    return {
      ...toRefs(pageData),
      getNumber: globalsets.getNumber
    }
  }
})
